import axios from "../../axiosConfig/axios";

export const addProduct = {
    async AddProduct(data) {
        console.log(data)
        return axios.patch(`addProduct`,
             data?.data,data?.config
            )

    },
    async fetchProduct(data) {
        console.log(data)
        return axios.patch(`municipalProduct`,
             data?.data,data?.config
            )

    },
    async fetchExceldata(data) {
        console.log(data)
        return axios.patch(`readExcel`,
             data?.data,data?.config
            )

    },
    async EditProduct(data) {
        console.log(data)
        if(data?.type == "text"){
            return axios.patch(`editProduct`,
            data?.data,data?.config,
           )
       
        }else{

        return axios.patch(`editProduct`,
             data?.data,data?.config
            )
        }

    },
    async saveProduct(data) {
        return axios.post(`product`,
        {
           productList: data?.type ==".csv" || data?.type == '.xlsx' ? data?.productList?.splice(0,10) : data?.pdfData,
           type:data?.type,
           productCategoty:data?.productCategoty,
           productType:data?.productType
        },
    {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': data?.config?.headers?.Authorization
        }
    }
            )

    },
    async getProduct(token) {
        return axios.get(`getProduct`,
    {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        }
    }
            )

    }
    
}